import {
  WARRANTIES_FETCH_REQUEST,
  WARRANTIES_FETCH_SUCCESS,
  WARRANTIES_FETCH_FAILURE,
} from '../actions/constants'
import { WarrantiesActions } from '../actions/warranties'

export interface IWarranty {
  id: string
  codice_prodotto: string
  data_acquisto: string
}

export interface WarrantiesState {
  data: IWarranty[]
  fetching: boolean
  error: boolean
}

export const WARRANTIES_INITIAL_STATE: WarrantiesState = {
  data: [],
  fetching: false,
  error: false,
}

export const warranties = (
  state: WarrantiesState = WARRANTIES_INITIAL_STATE,
  action: WarrantiesActions
) => {
  switch (action.type) {
    case WARRANTIES_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      }
    case WARRANTIES_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.warranties,
      }
    case WARRANTIES_FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
      }
    default:
      return state
  }
}
